import React, { useEffect, useState } from 'react';
import ChatContent from './ChatContent';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { findChat } from '../../redux/actions/chat/findChat';
import Loading from '../../components/Loading/Loading';
import MessageModal from '../../components/Modal/MessageModal';
import clsx from 'clsx';
import { resetFindChat } from '../../redux/slices/chat.slice';

export default function ChatModal({ textBtn = 'Написать сообщение', className, userType, userId, employerId, vacancyId }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    findChat: { data: findChatData, error: findChatError, loading: findChatLoading },
  } = useSelector((state) => state.chat);
  const [messageOpen, setMessageOpen] = useState(false);
  const [userMessageModal, setUserMessageModal] = useState();
  const [findChatId, setFindChatId] = useState();
  const handleMessageClose = () => {
    setMessageOpen(false);
  };
  useEffect(() => {
    if (userType && (employerId || userId) && !vacancyId) {
      let senderType = 'staff';
      let receiverType = userType;
      let chatType = receiverType == 'employer' ? 'support' : `${senderType}_${receiverType}`;
      let findChatParams = receiverType == 'employer' ? { receiver_employer_id: employerId } : { receiver_user_id: userId };
      dispatch(findChat({ type: chatType, receiver_type: receiverType, ...findChatParams }));
    }
  }, [employerId, userId, userType, vacancyId]);

  useEffect(() => {
    if (vacancyId && employerId) {
      dispatch(findChat({ type: 'staff_employer', receiver_type: 'employer', vacancy_id: vacancyId, receiver_employer_id: employerId }));
    }
  }, [vacancyId, employerId]);

  useEffect(() => {
    if (vacancyId && userId) {
      dispatch(findChat({ type: 'staff_candidate', receiver_type: 'candidate', vacancy_id: vacancyId, receiver_user_id: userId }));
    }
  }, [vacancyId, userId]);

  // useEffect(() => {
  //   if (vacancyId && open) {
  //     let senderType = 'staff';
  //     let receiverType = userType;
  //     let chatType = `${senderType}_${receiverType}`;
  //     dispatch(findChat({ type: chatType, receiver_type: data?.user?.type, receiver_user_id: userId }));
  //   }
  // }, [vacancyId, open]);
  useEffect(() => {
    if (findChatError) {
      setUserMessageModal({
        value: userId,
        employerId,
        type: userType,
      });
      dispatch(resetFindChat());
    }
  }, [findChatError]);
  useEffect(() => {
    if (findChatData) {
      setFindChatId(findChatData?.id);
      dispatch(resetFindChat());
    }
  }, [findChatData]);
  console.log(userMessageModal);

  return (
    <>
      {' '}
      <button
        type="button"
        className={clsx(className ?? 'text-center text-[14px] border rounded py-2 px-4 text-white  mr-2 w-full break-words p-2 xs:w-full hover:bg-[#069488] bg-[#00B2A4]')}
        onClick={() => {
          if (!findChatLoading) {
            if (userMessageModal) {
              setMessageOpen(true);
            } else {
              navigate(`/chat/${findChatId}`);
            }
          }
        }}>
        {textBtn}
      </button>
      {userMessageModal && <MessageModal open={messageOpen} onCancel={handleMessageClose} user={userMessageModal} isWrapButton />}
    </>
  );
}
